import React from "react";
import styles from "./Emandate.module.scss";
import MainHeader from "../../components/Header/MainHeader";
export default function ReversePenny({handlePannyDropAPI}) {

    return(
      <div className="wrapper">
        <div className="vertical-column-layout">
          <div className="vertical-column-top">
            <MainHeader title="Penny Drop" />
            <p className={styles.reversePennyLabel}>Please pay ₹1 to verify your bank account</p>
            <p className={`${styles.reversePennySubLabel} mb-2`}>Please complete your reverse Penny process for loan disbursal.</p>
            <div className={`${styles.reverseImage}`}>
              <img src="/images/reverse-penny-drop.png" alt="" />
            </div>

            <p className={`${styles.blueText} mt-2`}>₹1 will be returned to your account within 24-48 hours.</p>
          </div>

          <div className="vertical-column-bottom">
            <button className="button" type="submit" onClick={handlePannyDropAPI}>
              Continue <i className="shine"></i>
            </button>
          </div>
        </div>
      </div> 

    )
}